import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
// styles required by the installed xyflow/react package
import '@xyflow/react/dist/style.css';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { TenantProvider } from './contexts/TenantContext';
import { WorkspaceProvider } from './contexts/WorkspaceContext';
import { getKeycloakConfig } from './config/keycloak.config';
import { Toaster } from '@/components/ui/sonner';
import { queryClient } from '@/lib/queryClient';
import Clarity from '@microsoft/clarity';


const keycloakConfig = getKeycloakConfig();

const projectId = "v8kfukfwyj";

Clarity.init(projectId);

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider keycloakConfig={keycloakConfig}>
          <TenantProvider>
            <WorkspaceProvider>
              <App />
              <Toaster />
            </WorkspaceProvider>
          </TenantProvider>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}
